export const LOWERCASE = "One lowercase character";
export const UPPERCASE = "One uppercase character";
export const NUMBER = "One number";
export const SPECIAL = "One special character, e.g. !, @, &, (, %";
export const MINIMUM = "8 characters minimum";
export const MAXIMUM = "25 characters maximum";
export const MATCHING = "To match in both boxes";
export const NO_DATES_ALLOWED = "No dates allowed";
export const FORBIDDEN_STRING = "No forbidden words (e.g. S3cur!ty, 1234, £)";
export const NO_USERNAME_IN_PASSWORD = "No username in password";

export const forbiddenStrings = [
    "S3cur!ty",
    "S3curity",
    "P@ssw0rd",
    "2345",
    "5432",
    "1111",
    "1234",
    "dragon",
    "qwerty",
    "monkey",
    "letmein",
    "abc",
    "pass",
    "word",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "partner",
    "life",
    "£"
];

const PASSWORD_MAX_LENGTH = 25;
const PASSWORD_MIN_LENGTH = 8;

export function validate(username, password, confirmedPassword) {
    if (password.length === 0) {
        return [];
    }

    const validationFailures = [];

    if (!/^(?=.*[a-z]).+$/.test(password)) {
        validationFailures.push(LOWERCASE);
    }

    if (!/^(?=.*[A-Z]).+$/.test(password)) {
        validationFailures.push(UPPERCASE);
    }

    if (!/^(?=.*[0-9]).+$/.test(password)) {
        validationFailures.push(NUMBER);
    }

    if (!/^(?=.*[_\W]).+$/.test(password)) {
        validationFailures.push(SPECIAL);
    }

    if (/(([^1-9]0?[1-9]|[12]\d|3[01])([.\-/])(0?[1-9]|1[012])\3\d{2,4})/g.test(password)) {
        validationFailures.push(NO_DATES_ALLOWED);
    }

    if (password.length < PASSWORD_MIN_LENGTH) {
        validationFailures.push(MINIMUM);
    }

    if (password.length > PASSWORD_MAX_LENGTH) {
        validationFailures.push(MAXIMUM);
    }

    if (forbiddenStrings.some(string => password.toLowerCase().includes(string.toLowerCase()))) {
        validationFailures.push(FORBIDDEN_STRING);
    }

    if (
        username &&
        password &&
        validationFailures.length === 0 &&
        password.toLowerCase().includes(username.toLowerCase())
    ) {
        validationFailures.push(NO_USERNAME_IN_PASSWORD);
    }

    if (password !== confirmedPassword) {
        validationFailures.push(MATCHING);
    }

    return validationFailures;
}
